import { useState } from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { s3ImageLink } from "@/utils/links";

const GLOBAL_SUPPORT_EMAIL = "yoyo@ahalab.ai";

export default function AccountManagerSupportNotice() {
  const { t } = useTranslation();
  const [showWechatQr, setShowWechatQr] = useState(false);

  return (
    <>
      <div className="rounded-lg border border-[#E5E5E5] bg-[#FAFAFA] px-5 py-2.5 text-[10px] font-medium leading-[15px] text-[#404040] md:rounded-xl md:text-xs md:leading-3">
        <span className="md:mb-3 md:block">
          {t("components.chargeModal.supportSignUpNotice")}
        </span>{" "}
        <span className="md:mb-3 md:block">
          {t("components.chargeModal.supportContactPrompt")}
        </span>{" "}
        <span className="md:mb-3 md:block">
          {t("components.chargeModal.globalSupportLabel")} {" "}
          <a
            className="text-inherit underline"
            href={`mailto:${GLOBAL_SUPPORT_EMAIL}`}
          >
            {GLOBAL_SUPPORT_EMAIL}
          </a>
        </span>{" "}
        <span className="md:block">
          {t("components.chargeModal.chineseSupportLabel")} {" "}
          <button
            type="button"
            className="cursor-pointer border-0 bg-transparent p-0 text-inherit underline"
            aria-haspopup="dialog"
            onClick={() => setShowWechatQr(true)}
          >
            {t("components.chargeModal.scanQrCodeToContactUs")}
          </button>
        </span>
      </div>

      <Modal
        title={
          <span className="sr-only">
            {t("components.chargeModal.wechatSupportQrCode")}
          </span>
        }
        open={showWechatQr}
        footer={null}
        centered
        width={316}
        onCancel={() => setShowWechatQr(false)}
        styles={{
          content: {
            padding: "16px",
            border: "1px solid #E7E7E7",
            borderRadius: "8px",
            boxShadow: "0 11px 14px rgba(0, 0, 0, 0.08)",
          },
          header: {
            marginBottom: 0,
          },
          body: {
            lineHeight: 0,
          },
        }}
      >
        <img
          src={`${s3ImageLink}wechat-support.png`}
          alt={t("components.chargeModal.wechatSupportQrCode")}
          className="h-auto w-full rounded-lg"
          draggable={false}
        />
      </Modal>
    </>
  );
}
